import qs from 'qs';
import request from '../../../../../shared/lib/request';
import { API } from '../../../../../shared/constants';


const getTipi = () => request(
  {
    url: API.TIPO_PROFILO_COLLABORATORE,
    method: 'GET',
    params: {
      'order-by': [{
        type: 'field',
        field: 'posizione',
        direction: 'asc',
      }],
    },
    paramsSerializer: (params) => qs.stringify(params),
  });

const getTipiOptions = () => getTipi().then(
    (res) => res._embedded.tipoprofilocollaboratore.map((obj)=>{ return {value: obj.id, label: obj.nome }}) // eslint-disable-line
  ).then((data) => ({ options: data }));

const getProfiliByCollaboratore = (id) => request(
  {
    url: API.PROFILO_COLLABORATORE,
    method: 'GET',
    params: {
      filter: [{
        type: 'eq',
        field: 'collaboratore',
        value: id || null,
      }],
    },
    paramsSerializer: (params) => qs.stringify(params),
  });

const put = (content) => request(
  {
    url: `${API.PROFILO_COLLABORATORE}/${content.id}`,
    method: 'PUT',
    data: content,
  });

const create = (content) => request(
  {
    url: API.PROFILO_COLLABORATORE,
    method: 'POST',
    data: content,
  });

const ProfiloService = {
  getTipi,
  getTipiOptions,
  getProfiliByCollaboratore,
  put,
  create,
};

export default ProfiloService;



// WEBPACK FOOTER //
// ./app/shared/services/api/collaboratore/profilo/index.js